import _classCallCheck from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { AgentHome } from "../api/agent.api";
import { BaseResource } from "@kgsport-cms/common";
import "../common";
export var AgentHomeService = /*#__PURE__*/function (_BaseResource) {
  _inherits(AgentHomeService, _BaseResource);
  var _super = _createSuper(AgentHomeService);
  function AgentHomeService() {
    _classCallCheck(this, AgentHomeService);
    return _super.apply(this, arguments);
  }
  _createClass(AgentHomeService, [{
    key: "statistics",
    value: function statistics(params) {
      return this.requester.get(AgentHome.statistics, {
        params
      });
    }
  }, {
    key: "list",
    value: function list(params) {
      return this.requester.get(AgentHome.list, {
        params
      });
    }
  }, {
    key: "banner",
    value: function banner() {
      return this.requester.get(AgentHome.banner);
    }
  }, {
    key: "notice",
    value: function notice() {
      return this.requester.get(AgentHome.notice);
    }
  }, {
    key: "bonusDetail",
    value: function bonusDetail(params) {
      return this.requester.get(AgentHome.bonusDetail, {
        params
      });
    }
  }, {
    key: "totalWinDetail",
    value: function totalWinDetail(params) {
      return this.requester.get(AgentHome.totalWinDetail, {
        params
      });
    }
  }, {
    key: "activeMember",
    value: function activeMember(params) {
      return this.requester.get(AgentHome.activeMember, {
        params
      });
    }
  }, {
    key: "getShareLink",
    value: function getShareLink() {
      return this.requester.get(AgentHome.shareLink);
    }
  }]);
  return AgentHomeService;
}(BaseResource);